<template>
  <div class="owc-language-switcher" v-if="languageSwitch">
    <a
      v-for="lang in urlList"
      :key="lang.code"
      class="owc-language-switcher__item"
      :href="lang.url"
      @click="handleClick(lang.url)"
    >
      <span
        class="owc-language-switcher__language-item"
        :class="{ 'owc-language-switcher__language-item--active': lang.isCurrent }"
      >
        {{ lang.label }}
      </span>
    </a>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@/packages/_utils/Mixins/ComponentInitializeDispatcher';
import Logger from '../../_utils/common/Logger';
import { Language, LanguageSwitchComponent } from './LanguageSwitch';

/*
 * TODO: We are not using the mixin here because this module does not behave as the others do.
 *  It seems that it not meant to be used as a webcomponent and it does not receive the
 * normal datajson as a string but as an object. We have to decide as a team what shall be
 * done in these types of situations. For now it remais without the mixin so it can work properly.
 *
 * */
export default (ComponentInitializeDispatcher as LanguageSwitchComponent).extend({
  name: 'LanguageSwitch',
  props: {
    languageSwitch: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      urlList: [],
    };
  },
  created() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete('token');
    const queryParameters = `${params.toString()}`;
    const path = window.location.pathname || '';
    const activeLanguage = this.languageSwitch.find((language: Language) => language.isCurrent);

    if (activeLanguage) {
      const currentLangCode = activeLanguage.code;
      const pathParameters = path.split(activeLanguage.url)[1] || '';

      /**
       * Parses any extra parameters in the url to the correct language
       */
      this.urlList = this.languageSwitch.map(languageItem => {
        const item = languageItem;
        let parsedPathToLanguage = pathParameters;

        if (pathParameters) {
          // matching with slash, to ensure only language codes in path are replaced, instead of when the code is present in a bigger string
          parsedPathToLanguage = pathParameters
            .split('/')
            .map(el => {
              return el.replace(new RegExp(`^${currentLangCode}$`, 'gi'), languageItem.code.toLowerCase());
            })
            .join('/');
        }

        return {
          ...item,
          url: `${item.url}${parsedPathToLanguage}${queryParameters.length ? '?' + queryParameters : ''}`,
        };
      });
    } else {
      Logger.warn('No active language provided');
    }
  },
});
</script>

<style lang="scss">
.owc-language-switcher {
  display: flex;

  margin: 0 calc(var(--wb-spacing-xs) / 2);

  &__item {
    display: flex;

    align-items: center;
    justify-content: center;

    height: 48px;

    margin: 0 var(--wb-spacing-3xs);

    text-decoration: none;
  }
  &__language-item {
    @include wb-type-hint();

    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 20px;

    border-radius: 2px;

    overflow: hidden;

    color: var(--wb-grey-85);
    white-space: nowrap;
    text-transform: uppercase;

    background-color: var(--wb-grey-15);

    &--active {
      @include wb-type-hint-strong();

      color: var(--wb-white);
    }
  }
}
</style>
